import { cn } from "@ui/lib/utils";

type SolidBorderProps = {
  className?: string;
  color?: string; // Tailwind bg class, e.g. "bg-overlay-darker"
  side: "bottom" | "inline" | "left" | "right" | "top" | "vertical";
  thickness?: string; // Tailwind width class, e.g. "w-1", "w-px", "h-px"
};

const getSideClasses = (side: "bottom" | "inline" | "left" | "right" | "top" | "vertical", thickness: string) => {
  const baseClasses = "absolute";

  switch (side) {
    case "top":
      return cn(baseClasses, "left-0 top-0 h-px w-full", thickness);
    case "bottom":
      return cn(baseClasses, "bottom-0 left-0 h-px w-full", thickness);
    case "inline":
      return cn(baseClasses, "left-0 h-px w-full", thickness);
    case "left":
      return cn(baseClasses, "left-0 top-0 h-full w-px", thickness);
    case "right":
      return cn(baseClasses, "right-0 top-0 h-full w-px", thickness);
    case "vertical":
      return cn(baseClasses, "bottom-0 right-1/2 top-0 h-full w-1 -translate-x-1/2", thickness);
    default:
      return baseClasses;
  }
};

export const SolidBorder = ({ side, className, color = "bg-overlay-dark", thickness = "" }: SolidBorderProps) => {
  const classes = getSideClasses(side, thickness);

  const line = <div aria-hidden className={cn(classes, color, className)} />;

  if (side === "inline") {
    return <div className='h-px relative'>{line}</div>;
  }

  return line;
};

// Example usage for top and bottom borders
export const SolidBorderToTop = ({ className, color = "bg-overlay-dark" }: { className?: string; color?: string }) => (
  <div className='h-px relative w-full'>
    <SolidBorder className={className} color={color} side='top' />
  </div>
);

export const SolidBorderToBottom = ({
  className,
  color = "bg-overlay-dark",
}: {
  className?: string;
  color?: string;
}) => (
  <div className='h-px relative w-full'>
    <SolidBorder className={className} color={color} side='bottom' />
  </div>
);
